var map = {
	"./About": [
		411,
		9,
		689,
		411
	],
	"./About.jsx": [
		411,
		9,
		689,
		411
	],
	"./Background": [
		9088,
		9
	],
	"./Background.jsx": [
		9088,
		9
	],
	"./Education": [
		2449,
		9,
		64,
		449
	],
	"./Education.jsx": [
		2449,
		9,
		64,
		449
	],
	"./Error": [
		4784,
		9
	],
	"./Error.jsx": [
		4784,
		9
	],
	"./Experience": [
		7081,
		9,
		689,
		81
	],
	"./Experience.jsx": [
		7081,
		9,
		689,
		81
	],
	"./FallbackSpinner": [
		2150,
		9
	],
	"./FallbackSpinner.jsx": [
		2150,
		9
	],
	"./Header": [
		7084,
		9,
		84
	],
	"./Header.jsx": [
		7084,
		9,
		84
	],
	"./Home": [
		3792,
		9
	],
	"./Home.jsx": [
		3792,
		9
	],
	"./NavBar": [
		2143,
		9
	],
	"./NavBar.jsx": [
		2143,
		9
	],
	"./NuovaPagina": [
		5962,
		9
	],
	"./NuovaPagina.jsx": [
		5962,
		9
	],
	"./Projects": [
		1650,
		9,
		689,
		650
	],
	"./Projects.jsx": [
		1650,
		9,
		689,
		650
	],
	"./Skills": [
		895,
		9,
		689,
		895
	],
	"./Skills.jsx": [
		895,
		9,
		689,
		895
	],
	"./Social": [
		6741,
		9
	],
	"./Social.jsx": [
		6741,
		9
	],
	"./ThemeToggler": [
		2026,
		9
	],
	"./ThemeToggler.jsx": [
		2026,
		9
	],
	"./config/ParticlesConfig": [
		2479,
		9
	],
	"./config/ParticlesConfig.js": [
		2479,
		9
	],
	"./config/ParticlesConfigOrigin": [
		638,
		9,
		638
	],
	"./config/ParticlesConfigOrigin.js": [
		638,
		9,
		638
	],
	"./config/particles": [
		8243,
		3,
		243
	],
	"./config/particles.json": [
		8243,
		3,
		243
	],
	"./projects/ProjectCard": [
		1297,
		9,
		689,
		297
	],
	"./projects/ProjectCard.jsx": [
		1297,
		9,
		689,
		297
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1413;
module.exports = webpackAsyncContext;